(() => {
  if (window.__nnChapterOneBuilderLoaded) return;
  window.__nnChapterOneBuilderLoaded = true;

  const desktop = window.matchMedia('(min-width: 1100px)');
  let wrapper;
  let heroMarker;
  let builderMarker;

  const sections = () => ({
    hero: document.querySelector('section[id$="__hero_6atm6w"]'),
    builder: document.querySelector('[data-nn-map-builder]')
  });

  const mount = () => {
    const { hero, builder } = sections();
    if (!desktop.matches || !hero || !builder || wrapper?.isConnected) return;
    const legacyMount = builder.closest('.nn-map-builder-chapter-mount');
    hero.classList.remove('nn-chapter-with-builder');

    heroMarker ||= document.createComment('North & Noble Chapter 01 position');
    builderMarker ||= document.createComment('North & Noble builder position');
    if (!heroMarker.isConnected) hero.before(heroMarker);
    if (!builderMarker.isConnected) builder.before(builderMarker);

    wrapper = document.createElement('div');
    wrapper.className = 'nn-chapter-one-commerce';
    wrapper.setAttribute('aria-label', 'Chapter 01 — Build Your Compass');
    heroMarker.after(wrapper);
    wrapper.append(hero, builder);
    legacyMount?.remove();
    builder.classList.add('nn-map-builder--chapter-panel');

  };

  const unmount = () => {
    if (!wrapper?.isConnected) return;
    const { hero, builder } = sections();
    if (hero && heroMarker?.isConnected) heroMarker.after(hero);
    if (builder && builderMarker?.isConnected) {
      builderMarker.after(builder);
    } else if (builder) {
      const builderSection = document.querySelector('[id^="shopify-section-"][id$="__nn_map_builder_live"]');
      builderSection?.appendChild(builder);
    }
    builder?.classList.remove('nn-map-builder--chapter-panel');
    wrapper.remove();
    wrapper = undefined;
  };

  const sync = () => desktop.matches ? mount() : unmount();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync, { once: true });
  } else {
    sync();
  }
  desktop.addEventListener('change', sync);
  document.addEventListener('shopify:section:load', sync);
})();
